import {
    apiRequest,
    pensiunPegawaiDetail
} from "../../../../../services/adapters/kepegawaian/pensiunpegawaiService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", pensiunPegawaiDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository